const API_URL = process.env.REACT_APP_API_URL;

const config = {
    development: {
        API_URL: API_URL || 'http://localhost:8000/basic-api',
    },
    production: {
        API_URL: API_URL || '/basic-api'
    },
};

export default config[process.env.NODE_ENV || 'development'];


